import script from "./register.vue?vue&type=script&setup=true&lang=ts"
export * from "./register.vue?vue&type=script&setup=true&lang=ts"

import "./register.vue?vue&type=style&index=0&id=ab6f90ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab6f90ac"]])

export default __exports__